export const pluralize = (amount: number, one: string, more: string) => {
  return amount === 1 ? one : more;
};
